// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Mx4Qo","title":"styles_title__EQK5-","main":"styles_main__AS1NI","cancel-button":"styles_cancel-button__IuS-O"};